export const apiName: string = 'medidas';
export const medidasRouter: string = 'medidas';
export const medidasStorage: string = 'medidas';
export const medidasModuleName: any = {plural: 'Medidas', single: 'Medida'};

export const medidasQuery: any = {
    "where":{
        "ativo":true,
        "medida":{"regexp":"/REPLACEHERE/i"}
    },
    "order":"medida"
};


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/medidas/shared/data.service.ts
 **/